import React from "react";

const DeleteIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15.758"
      height="20.823"
      viewBox="0 0 15.758 20.823"
    >
      <g id="db-16" transform="translate(-88 -34)">
        <path
          id="Path_1200"
          data-name="Path 1200"
          d="M186.222,36.579v-.713a1.888,1.888,0,0,0-1.9-1.867h-3.428A1.887,1.887,0,0,0,179,35.867v.713h.938v-.713a.95.95,0,0,1,.961-.929h3.428a.953.953,0,0,1,.961.929v.713Z"
          transform="translate(-86.732)"
        />
        <path
          id="Path_1201"
          data-name="Path 1201"
          d="M125.23,206.366h9.544a1.412,1.412,0,0,0,1.407-1.412L136.2,193H123.8l.023,11.954A1.412,1.412,0,0,0,125.23,206.366Zm7.537-10.2a.469.469,0,0,1,.938,0v6.064a.469.469,0,1,1-.938,0Zm-3.236,0a.469.469,0,0,1,.938,0v6.064a.469.469,0,1,1-.938,0Zm-3.236,0a.469.469,0,0,1,.938,0v6.064a.469.469,0,1,1-.938,0Z"
          transform="translate(-34.121 -151.543)"
        />
        <path
          id="Path_1202"
          data-name="Path 1202"
          d="M103.758,102V99.469a.47.47,0,0,0-.469-.469H88.469a.47.47,0,0,0-.469.469V102a.47.47,0,0,0,.469.469h14.82A.47.47,0,0,0,103.758,102Z"
          transform="translate(0 -61.952)"
        />
      </g>
    </svg>
  );
};

export default DeleteIcon;
